export function compareURL(url1: string, url2: string, queryKeys: string[] = []) {
  if (typeof url1 !== 'string' || typeof url2 !== 'string') {
    return false
  }
  if (!url1.includes('://')) {
    url1 = window.location.protocol + '//' + url1
  }
  if (!url2.includes('://')) {
    url2 = window.location.protocol + '//' + url2
  }

  let url1Obj: URL
  let url2Obj: URL
  try {
    url1Obj = new URL(url1)
    url2Obj = new URL(url2)
  } catch (e) {
    return false
  }
  if (url1Obj.host + url1Obj.pathname !== url2Obj.host + url2Obj.pathname) {
    return false
  }
  for (const key of queryKeys) {
    if (url1Obj.searchParams.get(key) !== url2Obj.searchParams.get(key)) {
      return false
    }
  }
  return true
}

export function addUrlParams(url: string, params?: Record<string, string>) {
  if (!params || Object.keys(params).length === 0) {
    return url
  }
  const urlParams = url.includes('?')
    ? new URLSearchParams(url.split('?')[1])
    : new URLSearchParams()
  Object.keys(params).forEach(key => {
    urlParams.set(key, params[key])
  })
  return url.split('?')[0] + '?' + urlParams.toString()
}